const routes = [
  {
    path: 'aggridrowsort',
    name: 'aggridrowsort',
    component: () => import(/* webpackChunkName: "aggridrowsort" */ '@/modules/aggridrowsort/index.vue')
  },
];

export default routes;